export const HEADER_BLOCK_S09 = {
  "blockType": "HEADER",
  "blockDesign": "header_01",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px"
  },
  "position": "center",
  "headingsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "headingsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "headingsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "headings": [
    {
      "styleProps": {
        "font-size": "3.75rem",
        "line-height": "1",
        "padding": "20px 0px 20px 0px",
        "font-weight": "400",
        "color": "#333333",
        "font-family-cust": "",
        "font-family": "'Lato', sans-serif",
        "margin": "0px 0px 0px 0px",
        "font-family-bk": "'Lato', sans-serif"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1",
        "padding": "20px 0px 20px 0px"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "padding": "20px 0px 20px 0px"
      },
      "text": "Transforming Businesses"
    },
    {
      "text": " with Innovative Software Solutions",
      "styleProps": {
        "font-size": "3rem",
        "line-height": "1",
        "color": "#cccccc",
        "margin": "0px 0px 40px 0px",
        "font-family-bk": "'Lato', sans-serif",
        "font-family": "'Lato', sans-serif"
      },
      "stylePropsTab": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    },
    {
      "text": "Empowering growth, efficiency, and success through cutting-edge technology",
      "styleProps": {
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "color": "#808080"
      },
      "stylePropsTab": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "dynamicText": {
    "styleProps": {
      "font-size": "1.875rem",
      "line-height": "2.25rem",
      "padding": "10px 0px 10px 0px",
      "text-align": "center"
    },
    "stylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "stylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "strings": []
  },
  "descriptionsStyleProps": {
    "padding": "10px 0px 10px 0px",
    "text-align": "center"
  },
  "descriptionsStylePropsTab": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptionsStylePropsMob": {
    "padding": "10px 0px 10px 0px"
  },
  "descriptions": [],
  "buttonsStyleProps": {},
  "buttons": [],
  "emailSecStyleProps": {
    "background-color": "#ececec",
    "padding": "20px 20px 20px 20px",
    "border-radius": "1.5rem"
  },
  "subscription": {
    "showSection": "show",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com",
      "styleProps": {
        "background-color": "",
        "border-radius": "0.75rem"
      }
    },
    "buttonText": {
      "text": "Get Started",
      "styleProps": {
        "background-color": "",
        "color": "#ffffff",
        "background-image": "linear-gradient(to right,#00b09b,#6bceff)",
        "border-width": "0px",
        "border-radius": "1rem",
        "font-weight": "500",
        "padding": "12px 30px 12px 30px",
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "textsStyleProps": {
    "text-align": "center"
  },
  "texts": [
    {
      "type": "el",
      "sub_type": "html",
      "text": "Want to use a web browser? <a href='#'>Log in to Gusto</a>"
    }
  ],
  "editFormName": "HEADER_FORM_01",
  "metaDataId": 1745685780518,
  "afterIndex": -1,
  "blockId": 1745685780518,
  "textBlock": {
    "descriptions": [
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      },
      {
        "text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        "styleProps": {
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "color": "#ffffff"
        }
      }
    ],
    "headings": [
      {},
      {},
      {}
    ]
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "containerStyleProps": {
    "max-width": "1024px"
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  }
}